import FullScreenLayout from "layouts/MainLayout/FullScreenLayout";
import Retool from "pages/Retool";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { buildingStore } from "store/Building/BuildingStore";
import { userStore } from "store/UserStore";
import { VARIANT_COMPARISON_DOCS } from "utils";

const Variants = () => {
  const reportID = "6d73a35c-7405-11ef-b811-6b3026c65f4c";
  const { id: BuildingId } = useParams();
  const { userProfile } = userStore;
  const { t } = useTranslation();

  const embeddedData = {
    building_id: BuildingId,
    email: userProfile?.email,
    user_id: userProfile?.username,
    user_name: `${userProfile?.first_name} ${userProfile?.last_name}`,
  };

  return (
    <FullScreenLayout
      title={t("variants.title")}
      helpURL={VARIANT_COMPARISON_DOCS}
      buildingName={buildingStore.currentBuilding?.name}
    >
      <Retool url={reportID} embeddedData={embeddedData} />
    </FullScreenLayout>
  );
};

export default Variants;
